import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

import { FILE_CHANNEL_EMPTY_STATE_LEARN_MORE } from 'src/constants/modulesEmptyStates';
import { useModuleIcon } from 'src/hooks/useModuleIcon';
import { useFileChannelActionButton } from 'src/legacy/components/Files/ChannelContent/hooks/useFileChannelActionButton';

import { CreateButton } from '../Buttons';

import StandardPage from '.';

interface NoFilesStandardPageProps {
  onOptionSelected: (option: string) => void;
  isFolderLockedForClient?: boolean;
}

const useStyles = makeStyles()((theme) => ({
  root: {
    textAlign: 'left', // make sure all text elements are left aligned
    padding: theme.spacing(0, 2),
  },
}));

const NoFilesStandardPage: React.FC<NoFilesStandardPageProps> = ({
  onOptionSelected,
  isFolderLockedForClient = false,
}) => {
  const { classes } = useStyles();
  const Icon = useModuleIcon('files');
  const { t } = useTranslation();
  const { headerOptions, mainOptions } = useFileChannelActionButton();

  const actionButton = (
    <CreateButton
      key="new-file-btn"
      htmlId="new-file-btn"
      onClickOption={onOptionSelected}
      headerOptions={headerOptions}
      mainOptions={mainOptions}
      anchorOrigin={{
        horizontal: 'left',
        vertical: 'bottom',
      }}
      transformOrigin={{
        horizontal: 'left',
        vertical: 'top',
      }}
    >
      New
    </CreateButton>
  );

  // For read-only folders, show different message and hide action button
  const clientDescription = isFolderLockedForClient
    ? t(($) => $.page_files.no_files_description_cu_read_only)
    : t(($) => $.page_files.no_files_description_cu);

  return (
    <div className={classes.root}>
      <StandardPage
        title={t(($) => $.page_files.no_files_title)}
        topIcon={Icon}
        desc={t(($) => $.page_files.no_files_description_iu)}
        learnMoreLinkUrl={FILE_CHANNEL_EMPTY_STATE_LEARN_MORE}
        titleForClient={t(($) => $.page_files.no_files_title)}
        descForClient={clientDescription}
        actionButton={actionButton}
        actionButtonForClient={
          isFolderLockedForClient ? undefined : actionButton
        }
      />
    </div>
  );
};

export default NoFilesStandardPage;
